<div class="subscription-plan-selector">
  @if (currentSubscriptionPlan) {
    <section class="current-plan-section">
      <h2>Plano atual</h2>
      <mat-card class="plan-card current-plan">
        <mat-card-header>
          <mat-card-title>{{ currentSubscriptionPlan.displayName }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>Para condomínios com até {{ currentSubscriptionPlan.maxUsers ?? 'ilimitados' }} usuários*</p>
          <p class="note">* cada pessoa cadastrada no condomínio conta como um usuário, independentemente do número de unidades habitacionais</p>
        </mat-card-content>
      </mat-card>
      @if (currentSubscriptionPlan.deactivationDate) {
        <div class="cancelled-plan-notice" role="status">
          <mat-icon color="primary" aria-hidden="true">info</mat-icon>
          <span>Plano cancelado. Uso liberado até {{ formattedDeactivationDate() }}.</span>
        </div>
      }
      @if (condominiumId) {
        <div class="current-plan-actions">
          <button
            mat-raised-button
            color="warn"
            type="button"
            [disabled]="isCancellingSubscription || !!currentSubscriptionPlan?.deactivationDate"
            (click)="openCancelConfirmation()">
            @if (isCancellingSubscription) {
              <mat-spinner diameter="22" class="cancel-spinner"></mat-spinner>
            } @else {
              Cancelar
            }
          </button>
        </div>
      }
    </section>
  }

  <section class="plans-section">
    <h2>Planos</h2>
    @if (!currentSubscriptionPlan) {
      <h3>Você terá 30 dias grátis para testar</h3>
    }

    @if (isLoading) {
      <div class="loading-container">
        <p>Carregando planos...</p>
      </div>
    }

    @if (!isLoading && plans.length === 0) {
      <div class="empty-state">
        <p>Nenhum plano disponível</p>
      </div>
    }

    @if (!isLoading && plans.length > 0) {
      <div class="plans-grid">
        @for (plan of plans; track plan.id) {
          <mat-card 
            class="plan-card"
            [class.selected]="isPlanSelected(plan)"
            (click)="onPlanClick(plan)">
            <mat-card-header>
              <mat-card-title>{{ plan.displayName }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <p>Para condomínios com até {{ plan.maxUsers ?? 'ilimitados' }} usuários*</p>
              @if (plan.price != null) {
                <p class="plan-price">{{ plan.price | currency:'BRL' }}/mês</p>
              } @else {
                <p class="plan-price">Grátis</p>
              }
              <p class="note">* cada pessoa cadastrada no condomínio conta como um usuário, independentemente do número de unidades habitacionais</p>
            </mat-card-content>
          </mat-card>
        }
      </div>
    }
  </section>
</div>
